import React, { useState, useRef, useEffect } from "react";
import { createPortal } from "react-dom";
import Lottie from "lottie-react";

import GirlLottie from "../assets/json/sezione-05-img-01.json";
import VectorIpo from "../assets/images/Vector_ipo.png";

// Popups reali
import ModelloBusiness from "./popup/en/en-sezione-5-Modello";
import ModelloSostenibilita from "./popup/en/en-sezione-5-Sostenibilita";
import Stakeholder from "./popup/en/en-sezione-5-Stakeholder";
import AnalisiECG from "./popup/en/en-sezione-5-Analisi";
import Network from "./popup/en/en-sezione-5-Network";
import Premi from "./popup/en/en-sezione-5-Premi";
import Care from "./popup/en/en-sezione-5-Care";
import Documenti from "./popup/en/en-sezione-5-Documenti";
import StakeholderEngagement from "./popup/en/en-sezione-5-Engagement";
import arrowIcon from "../assets/images/Vector_btn.png";

import closeIcon from "../assets/images/close.png";

// Block “cliccabile” (button semantics + colore dinamico)
const Block = ({ color = "#357D9F", label, onClick }) => (
  <button
    type="button"
    onClick={onClick}
    // espongo il colore come CSS var (riutilizzabile nelle classi Tailwind)
    style={{ "--tile": color }}
    className="
      group relative flex flex-col items-start p-1 md:p-4
      h-full min-h-[60px] md:min-h-[200px]
      border-2 text-left transition-colors duration-200
      focus:outline-none focus-visible:ring-2 focus-visible:ring-[#0E3761]

      border-[var(--tile)] hover:bg-[var(--tile)]
    "
    aria-label={label}
  >
    <div
      className="
        font-semibold text-[10px] md:text-[18px] lg:text-[28px] leading-none transition-colors
        text-[#0E3761] group-hover:text-white
      "
    >
      {label}
    </div>

    {/* freccia: colore base = var(--tile), al hover diventa bianca */}
    <span
      className="
        absolute bottom-1 right-2 text-[12px] md:text-[30px]
        transition-colors text-[var(--tile)] group-hover:text-white
      "
    >
      &#8600;
    </span>
  </button>
);



// —————————————————————————————————————————————————————————————
// Configurazione delle tile (ordine identico alla tua griglia)
const TILES = [
  { id: "modello", color: "#c66529", label: "Business Model" },
  { id: "stakeholder-materialita", color: "#004996", label: "Stakeholders and Materiality Analysis" },
  { id: "modello-strategico", color: "#A3648F", label: "Sustainability Model" },
  { id: "analisi-esg-linee", color: "#3d8f30", label: "Integrated ESG analysis and Group strategic lines" },
  { id: "associazioni-network", color: "#5b6a24", label: "Participation in associations and membership in international networks" },
  { id: "premi-riconoscimenti", color: "#954e16", label: "Awards and recognitions" },
  { id: "taking-care", color: "#5188A1", label: "Taking care of us" },
  { id: "documenti-sostenibilita", color: "#004996", label: "Sustainability documents" },
];

// —————————————————————————————————————————————————————————————
export default function Sezione5EN() {
  const [openPopup, setOpenPopup] = useState(null);

  const [videoOpen, setVideoOpen] = useState(false);

  const renderPopup = () => {
    switch (openPopup) {
      case "modello":
        return <ModelloBusiness isOpen={true} onClose={() => setOpenPopup(null)} />;
      case "stakeholder-materialita":
        return <Stakeholder isOpen={true} onClose={() => setOpenPopup(null)} />;
      case "modello-strategico":
        return <ModelloSostenibilita isOpen={true} onClose={() => setOpenPopup(null)} />;
      case "analisi-esg-linee":
        return <AnalisiECG isOpen={true} onClose={() => setOpenPopup(null)} />;
      case "associazioni-network":
        return <Network isOpen={true} onClose={() => setOpenPopup(null)} />;
      case "premi-riconoscimenti":
        return <Premi isOpen={true} onClose={() => setOpenPopup(null)} />;
      case "taking-care":
        return <Care isOpen={true} onClose={() => setOpenPopup(null)} />;
      case "stakeholder-engagement":
        return <StakeholderEngagement isOpen={true} onClose={() => setOpenPopup(null)} />;
      case "documenti-sostenibilita":
        return <Documenti isOpen={true} onClose={() => setOpenPopup(null)} />;
      default:
        return null;
    }
  };

  return (
    <>
      <section id="sezione-sezioni" className="w-full bg-[#E7E3DF] py-10 md:pt-24">
        <h2 className="mb-5 px-6 block md:hidden text-[#0E3761]">
          Sections and highlights
        </h2>

        <div className="mx-auto pr-4 md:pr-6 flex flex-row gap-0 md:gap-0">
          {/* Colonna sinistra */}
          <div className="w-1/2 md:w-1/3 flex flex-col justify-start items-end">
            <Lottie
              animationData={GirlLottie}
              loop
              autoplay
              className="max-w-[100%] w-full h-auto select-none pointer-events-none"
            />

          </div>

          {/* Colonna destra */}
          <div className="w-1/2 md:w-2/3 flex flex-col gap-5 p-0 md:px-[80px] md:pr-[calc((100vw-1470px)/2)]">
            <h2 className="hidden text-[#0E3761] md:block mb-1">
              Sections and highlights
            </h2>

            <div className="grid grid-cols-2 md:grid-cols-3 items-start pl-[10px] md:pl-[0px] gap-2 md:[&>*:last-child]:col-span-2">
              {TILES.map((t) => (
                <Block
                  key={t.id}
                  color={t.color}
                  label={t.label}
                  onClick={() => setOpenPopup(t.id)}
                />
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Banner Ipovedenti */}
      <section className="hidden md:flex flex-row items-center justify-center p-6 gap-2">
        <img src={VectorIpo} alt="ipovedenti" className="w-[24px]"/>
        <p className="text-[18px] md:text-[24px]">
          The graphic design of this minisite was designed with the needs of visually impaired people in mind.
        </p>
      </section>

      {/* VIDEO POPUP */}
      {videoOpen &&
        createPortal(
          <div
            id="socio-video-modal"
            className="fixed inset-0 z-[2600] bg-black/70 flex items-center justify-center p-4"
            role="dialog"
            aria-modal="true"
            aria-label="Riproduzione video spot SO’ SOCIO"
            onMouseDown={(e) => {
              if (e.currentTarget === e.target) setVideoOpen(false);
            }}
          >
            <div className="relative w-full max-w-[960px]">
              {/* Close */}
              <button
                onClick={() => setVideoOpen(false)}
                className="absolute -top-10 right-0 inline-flex h-9 w-9 items-center justify-center rounded-full text-white/90 bg-white/10 border border-white/20 hover:bg-white/20 transition"
                title="Chiudi video"
                aria-label="Chiudi video"
              >
                <img src={closeIcon} alt="Chiudi" className="h-4 w-4 invert" />
              </button>

              {/* 16:9 wrapper */}
              <div className="relative w-full" style={{ paddingTop: "56.25%" }}>
                <iframe
                  src="https://www.youtube-nocookie.com/embed/bNUKYOivkOI?rel=0&modestbranding=1"
                  title="SO’ SOCIO — Spot"
                  allow="autoplay; fullscreen; picture-in-picture"
                  allowFullScreen
                  className="absolute inset-0 w-full h-full rounded-lg shadow-xl"
                />
              </div>
            </div>
          </div>,
          document.body
        )}

      {/* Render del popup selezionato */}
      {renderPopup()}
    </>
  );
}
